// src/pages/Appli/AppliAdmin/ListingClients/data/associations.data.js

export const ASSOCIATION_STATUSES = [
  {
    value: "Nouveau Prospect",
    group: "prospect",
    chartColor: "#38bdf8",
    tone:
      "bg-sky-100 text-sky-700 ring-sky-200 dark:bg-sky-500/15 dark:text-sky-300 dark:ring-sky-500/30",
  },
  {
    value: "Prospect contacté",
    group: "prospect",
    chartColor: "#22d3ee",
    tone:
      "bg-cyan-100 text-cyan-700 ring-cyan-200 dark:bg-cyan-500/15 dark:text-cyan-300 dark:ring-cyan-500/30",
  },
  {
    value: "Devis envoyés",
    group: "prospect",
    chartColor: "#818cf8",
    tone:
      "bg-indigo-100 text-indigo-700 ring-indigo-200 dark:bg-indigo-500/15 dark:text-indigo-300 dark:ring-indigo-500/30",
  },
  {
    value: "En Test",
    group: "test",
    chartColor: "#f59e0b",
    tone:
      "bg-amber-100 text-amber-700 ring-amber-200 dark:bg-amber-500/15 dark:text-amber-300 dark:ring-amber-500/30",
  },
  {
    value: "Devis signés & attente règlements",
    group: "prospect",
    chartColor: "#34d399",
    tone:
      "bg-emerald-100 text-emerald-700 ring-emerald-200 dark:bg-emerald-500/15 dark:text-emerald-300 dark:ring-emerald-500/30",
  },
  {
    value: "Clients MAC",
    group: "client",
    chartColor: "#8b5cf6",
    tone:
      "bg-violet-100 text-violet-700 ring-violet-200 dark:bg-violet-500/15 dark:text-violet-300 dark:ring-violet-500/30",
  },
  {
    value: "Clients Website",
    group: "client",
    chartColor: "#3b82f6",
    tone:
      "bg-blue-100 text-blue-700 ring-blue-200 dark:bg-blue-500/15 dark:text-blue-300 dark:ring-blue-500/30",
  },
  {
    value: "Clients MAM",
    group: "client",
    chartColor: "#ec4899",
    tone:
      "bg-pink-100 text-pink-700 ring-pink-200 dark:bg-pink-500/15 dark:text-pink-300 dark:ring-pink-500/30",
  },
  {
    value: "Clients SAAS",
    group: "client",
    chartColor: "#d946ef",
    tone:
      "bg-fuchsia-100 text-fuchsia-700 ring-fuchsia-200 dark:bg-fuchsia-500/15 dark:text-fuchsia-300 dark:ring-fuchsia-500/30",
  },
  {
    value: "Professionnel",
    group: "professional",
    chartColor: "#64748b",
    tone:
      "bg-slate-200 text-slate-700 ring-slate-300 dark:bg-slate-500/20 dark:text-slate-200 dark:ring-slate-500/30",
  },
  {
    value: "Perdu",
    group: "lost",
    chartColor: "#ef4444",
    tone:
      "bg-red-100 text-red-700 ring-red-200 dark:bg-red-500/15 dark:text-red-300 dark:ring-red-500/30",
  },
];

export const ASSOCIATION_STATUS_VALUES = ASSOCIATION_STATUSES.map(
  ({ value }) => value,
);

export const ASSOCIATION_STATUS_INDEX = Object.fromEntries(
  ASSOCIATION_STATUS_VALUES.map((status, index) => [status, index]),
);

export const ASSOCIATION_STATUS_META = Object.fromEntries(
  ASSOCIATION_STATUSES.map((status) => [status.value, status]),
);

export const ASSOCIATION_PRODUCTS = [
  "MonAppliClub Standard",
  "MonAppliClub Light",
  "MonAppliComité",
  "MonAppliLigue",
  "MonAppliOmnisport",
  "Judo Coach Pro",
  "Judo Présence Pro",
  "MonAppliTournoi",
  "MonAppliAG",
  "MonAppliMairie",
  "MonAppliAsso",
  "Website",
];

export const DEFAULT_ASSOCIATION_STATUS = "Nouveau Prospect";

export function getAssociationStatusMeta(status) {
  return (
    ASSOCIATION_STATUS_META[status] || {
      value: status || "Statut inconnu",
      group: "unknown",
      chartColor: "#94a3b8",
      tone:
        "bg-slate-100 text-slate-700 ring-slate-200 dark:bg-slate-800 dark:text-slate-300 dark:ring-slate-700",
    }
  );
}

export const ASSOCIATION_QUILL_MODULES = {
  toolbar: [
    [{ header: [1, 2, 3, false] }],
    ["bold", "italic", "underline", "strike"],
    [{ color: [] }, { background: [] }],
    [
      { list: "ordered" },
      { list: "bullet" },
      { indent: "-1" },
      { indent: "+1" },
    ],
    ["blockquote", "link"],
    ["clean"],
  ],
};

export const ASSOCIATION_QUILL_FORMATS = [
  "header",
  "bold",
  "italic",
  "underline",
  "strike",
  "color",
  "background",
  "list",
  "bullet",
  "indent",
  "blockquote",
  "link",
];